import { ProgramBenefitsPayload } from '~/common/types/types';

const programBenefitsPayload: ProgramBenefitsPayload = {
  items: [
    {
      title: 'programBenefits.item0.title',
      description: 'programBenefits.item0.description',
    },
    {
      title: 'programBenefits.item1.title',
      description: 'programBenefits.item1.description',
    },
    {
      title: 'programBenefits.item2.title',
      description: 'programBenefits.item2.description',
    },
    {
      title: 'programBenefits.item3.title',
      description: 'programBenefits.item3.description',
    },
  ],
};

export { programBenefitsPayload };
